/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_501Inputs */

const vi_carrier_status_501 = /** @type {(inputs: Carrier_Status_501Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát thành công`)
};

/**

* @param {Carrier_Status_501Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_501 = /** @type {((inputs?: Carrier_Status_501Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_501Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_501(inputs)
});